import { render, staticRenderFns } from "./AddressChangeModal.vue?vue&type=template&id=0ba46f5d&scoped=true&"
import script from "./AddressChangeModal.vue?vue&type=script&lang=ts&"
export * from "./AddressChangeModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddressChangeModal.vue?vue&type=style&index=0&id=0ba46f5d&lang=scss&scoped=true&"
import style1 from "./AddressChangeModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba46f5d",
  null
  
)

export default component.exports